import { account, checkout, product, products, promotion } from './actions';
import { identify, reset } from './segment';

const track = { account, product, products, promotion, checkout };
export { reset, track, identify };
